import { create } from "zustand";
import { devtools } from "zustand/middleware";
import * as Sentry from "@sentry/react";
import storageService from "@/services/middleware/storageService";
import type { MeUser } from "@/types/model/User";

interface UsersState {
  user: MeUser;
  setUser: (data: any) => void;
  setSensorReceivingTraffic: (data: boolean) => void;
  setAccountUsers: (data: any) => void;
  accountUsers: any;
  setUsersLoading: (loading: boolean) => void;
}

export const useUsersStore = create<UsersState>()(
  devtools(
    (set) => ({
      user: {},
      setUser: (data: any) =>
        set(() => {
          Sentry.setUser({
            id: data.id?.toString(),
            email: data.email,
            username: data.companyName,
            planMode: data.planMode,
            planType: data.planType,
          });

          // Store legacy planType for backward compatibility
          if ("planMode" in data) {
            storageService.setItem("user-type", (data as MeUser).planType);
          } else {
            storageService.removeItem("user-type");
          }

          if ("sensorIntegrated" in data && data.sensorIntegrated === true) {
            storageService.setItem("integrated", true);
          }

          return {
            user: {
              ...data,
              sensorIntegrated: data?.sensorIntegrated || false,
            },
          };
        }),
      setSensorReceivingTraffic: (data: boolean) =>
        set((state) => ({
          user: {
            ...state.user,
            sensorIntegrated: data,
          },
        })),
      accountUsers: { usersData: [], isUsersLoading: true },
      setAccountUsers: (data: any) =>
        set((state) => ({
          accountUsers: {
            ...state.accountUsers,
            usersData: data,
          },
        })),
      setUsersLoading: (loading: boolean) =>
        set((state) => ({
          accountUsers: { ...state.accountUsers, isUsersLoading: loading },
        })),
    }),
    {
      name: "UsersStore", // shows up in the DevTools store list
    }
  )
);
